// extracted by mini-css-extract-plugin
export var progressBar = "_j5-0";
export var progressBarInner = "_j5-1";